<template>
  <div class="relative group">
    <div
      class="aspect-square bg-slate-50 rounded-lg border border-slate-200 overflow-hidden cursor-move transition-all duration-200"
      :class="{
        'border-blue-300 bg-blue-50': isDropTarget,
        'opacity-75 scale-95': isDragging,
        'hover:border-blue-300': !isDragging,
      }"
      draggable="true"
      @dragstart="$emit('dragStart', $event)"
      @dragover.prevent="$emit('dragOver')"
      @drop.prevent="$emit('drop')"
      @dragend="$emit('dragEnd')"
    >
      <img 
        v-if="imageUrl"
        :src="imageUrl" 
        class="w-full h-full object-cover" 
        alt="preview" 
      />
      <div v-else class="w-full h-full flex items-center justify-center">
        <font-awesome-icon icon="image" class="text-slate-400 text-2xl" />
      </div>
    </div>
    
    <span 
      v-if="isCover" 
      class="absolute top-2 left-2 px-2 py-1 bg-blue-600 text-white text-xs font-medium rounded"
    >
      Okładka
    </span>
    
    <button
      v-if="showRemoveButton"
      type="button"
      class="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full p-0 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600 flex items-center justify-center"
      @click="$emit('remove')"
    >
      <font-awesome-icon icon="times" class="text-xs" />
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  imageUrl: string;
  isCover: boolean;
  showRemoveButton: boolean;
  isDragging: boolean;
  isDropTarget: boolean;
}>();

defineEmits<{
  dragStart: [event: DragEvent];
  dragOver: [];
  drop: [];
  dragEnd: [];
  remove: [];
}>();
</script>

